export const CLOSE_MONITOR_TAB_FOOTER = 'close_monitor_tab_footer';
export const OPEN_MONITOR_TAB_FOOTER = 'open_monitor_tab_footer';
export const CHANGE_MONITOR_SCREEN_MENU = 'change_monitor_screen_menu';
export const CLEAN_MONITOR_SCREEN_STATUS = 'clean_monitor_screen_status';